/* eslint-disable no-nested-ternary */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { history, getPath, getValueOfAttribut } from 'helpers';
import { userActions, platformActions } from 'actions';
import logo from 'styles/assets/images/White.svg';
import { changePlatform } from 'helpers/Platform';
import withlandingstyle from './WithLandingStyle';
import { platformConstants, userConstants } from '../../constants';
import {
  selectPlatformList,
  selectActivePlatformList,
  isPlatformDeactivated,
} from '../../selectors/platform';

const { HAS_DRY_PRODUCTS_KEY, HAS_FROZEN_PRODUCTS_KEY, HAS_FRESH_PRODUCTS_KEY } = platformConstants;

/** Scale down the text horizontally if it overflows its container. */
function fitText(node) {
  if (!node) return;
  const el = node;
  el.style.transform = '';
  const { scrollWidth, clientWidth } = el;
  if (scrollWidth > clientWidth && clientWidth > 0) {
    el.style.transform = `scaleX(${clientWidth / scrollWidth})`;
  }
}

class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.headlineEls = [];
    this.wrapperRef = null;
    this.resizeObserver = null;
    this.setWrapperRef = (el) => {
      this.wrapperRef = el;
    };
  }

  componentDidMount() {
    const { userInfo, fetchPlatforms, handleClickLogout } = this.props;
    if (!userInfo || !Object.keys(userInfo).length) {
      handleClickLogout();
      return;
    }
    // The supplier picker is not meant for super admins: their landing is the
    // configuration page. PrivateRoute's super-admin bypass would otherwise let
    // them render this page (it ignores the route's `roles` whitelist).
    if (userInfo.type === userConstants.TYPE_SUPER_ADMIN) {
      history.push(getPath('configuration'));
      return;
    }
    fetchPlatforms();
    this.setupResizeObserver();
  }

  componentDidUpdate() {
    requestAnimationFrame(() => this.fitAllHeadlines());
    this.setupResizeObserver();
  }

  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  setupResizeObserver() {
    if (this.resizeObserver || !this.wrapperRef) return;
    this.resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => this.fitAllHeadlines());
    });
    this.resizeObserver.observe(this.wrapperRef);
  }

  fitAllHeadlines() {
    this.headlineEls = [];
    if (this.wrapperRef) {
      this.wrapperRef.querySelectorAll('.landing__headline').forEach((el) => {
        this.headlineEls.push(el);
      });
    }
    this.headlineEls.forEach(fitText);
  }

  showTemperatures(platform) {
    const { attributs } = platform;
    const hasDryProducts = Number(getValueOfAttribut(attributs || [], HAS_DRY_PRODUCTS_KEY));
    const hasFreshProducts = Number(getValueOfAttribut(attributs || [], HAS_FRESH_PRODUCTS_KEY));
    const hasFrozenProducts = Number(getValueOfAttribut(attributs || [], HAS_FROZEN_PRODUCTS_KEY));
    const temperatures = [];
    if (hasDryProducts) {
      temperatures.push(
        <div key="dry" className="landing__headline-temperatures">
          <i className="Circle__icon-yellow icon-dry" />
          <span className="landing__headline-decription">Sec</span>
        </div>
      );
    }
    if (hasFreshProducts) {
      temperatures.push(
        <div key="fresh" className="landing__headline-temperatures">
          <i className="Circle__icon-green icon-apple" />
          <span className="landing__headline-decription">Frais</span>
        </div>
      );
    }
    if (hasFrozenProducts) {
      temperatures.push(
        <div key="frozen" className="landing__headline-temperatures">
          <i className="Circle__icon-blue icon-snow" />
          <span className="landing__headline-decription">Surgelé</span>
        </div>
      );
    }
    return temperatures;
  }

  render() {
    const { className, handleClickLogout, platforms = [], activePlatforms = [], user } = this.props;
    const allPlatformsDeactivated = platforms.length > 0 && activePlatforms.length === 0;

    return (
      <div className={className}>
        <div className="landing__background fade-in">
          <div>
            <div className="landing__container">
              <img className="landing__logo" src={logo} alt="logo in white" />
              <h6 className="landing__logo-text">Commande.com</h6>
            </div>
            <span className="landing_logout-icon" onClick={handleClickLogout}>
              <span className="landing_logout">DÉCONNEXION</span>
              <span className="button-circular__icon">
                <i className="icon-logout-landing" />
              </span>
            </span>
          </div>
          <div className="landing__provider">
            {allPlatformsDeactivated ? (
              <div className="landing__disclaimer">
                <div className="landing__disclaimer-text">
                  <span className="landing__disclaimer-title">IMPORTANT</span>
                  <br />
                  <br />
                  Bonjour, une nouvelle version de{' '}
                  <a href="https://client.commande.com" target="_blank" rel="noopener noreferrer">
                    commande.com
                  </a>{' '}
                  est disponible.
                  <br />
                  <br />
                  <a href="https://client.commande.com" target="_blank" rel="noopener noreferrer">
                    Accéder à la nouvelle version de commande.com
                  </a>
                  <br />
                  <br />
                  Ou copiez/collez ce lien dans votre barre de recherche :{' '}
                  <a href="https://client.commande.com" target="_blank" rel="noopener noreferrer">
                    https://client.commande.com
                  </a>
                </div>
              </div>
            ) : (
              <>
                <div className="landing__container-label">
                  <h6 className="landing__label">Sélection du fournisseur :</h6>
                </div>
                <div className="landing__provider-wrapper" ref={this.setWrapperRef}>
                  {activePlatforms.map((platform) => {
                    const deactivated = isPlatformDeactivated(platform);
                    return (
                      <span
                        key={platform.id}
                        className={`landing__provider-container fade-in-with-translate-y${
                          deactivated ? ' landing__provider--deactivated' : ''
                        }`}
                        onClick={() => changePlatform(platform.id, user)}
                      >
                        <div className="landing__provider-content">
                          <span className="landing__headline">{platform.name}</span>
                          <div className="landing__temperatures-wrap">
                            {this.showTemperatures(platform)}
                          </div>
                        </div>
                      </span>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { user } = state;
  return {
    user,
    userInfo: user.information,
    platforms: selectPlatformList(state),
    activePlatforms: selectActivePlatformList(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchPlatforms: () => {
    dispatch(platformActions.fetchPlatforms());
  },
  handleClickLogout: () => {
    dispatch(userActions.logout());
    history.push(getPath('login'));
  },
});

LandingPage.propTypes = {
  handleClickLogout: PropTypes.func.isRequired,
  className: PropTypes.string,
  fetchPlatforms: PropTypes.func.isRequired,
  platforms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  activePlatforms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  user: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(withlandingstyle(LandingPage));
